import React from "react"
// import {Link} from 'gatsby'
import Img from "gatsby-image"

export default function EventCard({title, date, speakers, slug, thumb}) {
    return (
        // <Link to={"/events/" + slug} key={title}>
            <div className="card-container" key={title}>
                <div >
                <Img className="card-image" fluid={thumb} alt="poster"/>
                </div>
                <div className="card-details">
                <h2>{title}</h2>
                <h5>{date}</h5>
                <p>{speakers}</p>
                </div>
            </div>
        // </Link>
    )
  }
  